import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Helper } from './app/shared/classes';

if (environment.production) {
  enableProdMode();
}

// If the browser restores a page from the back/forward cache (e.g. Back after
// the logout redirect chain), reload so stale logged-in UI never resumes
// against a dead session.
window.addEventListener('pageshow', (event: PageTransitionEvent) => {
  if (event.persisted) {
    window.location.reload();
  }
});

const loadingElement = document.querySelector(".app-loader");

platformBrowserDynamic().bootstrapModule(AppModule)
.then((moduleRef) => {
	// Set the injector instance for Helper class
	// this is used for google tag manager service
    Helper.setInjector(moduleRef.injector);
  })
  .then(() => setTimeout(() => loadingElement.remove(), 750))
  .catch(err => console.error(err));
